import { Attributes, DateUtils, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { PaymentType } from '../PaymentType';

export default class PaymentExportPagedCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.add(DateUtils.today(), { months: -1 });

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.today();

    @Attributes.Nullable()
    public entityId: number | null = null;

    @Rules.Required()
    public paymentType: PaymentType = PaymentType.Dividend;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Payment Export Paged Criteria";
    }
}